<script setup>
defineProps({
  size: { type: String, default: 'md' },
  label: { type: String, default: 'Loading' },
})
</script>

<template>
  <span
    class="spinner"
    :class="{ 'spinner--sm': size === 'sm', 'spinner--lg': size === 'lg' }"
    role="status"
    :aria-label="label"
  />
</template>
